import { combineReducers } from "redux";

import _cart from "./_cart";
import _root from "./_root";

export default combineReducers({
  cache: _root,
  cart: _cart
});
